// @ts-ignore
import iconFont from 'react-native-vector-icons/Fonts/Feather.ttf';
export default function setupBaseStyle() {
    const baseStyles = `
@font-face {
  font-display: swap;
  src: url(${iconFont});
  font-family: Feather;
}
`;
    const style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
        style.styleSheet.cssText = baseStyles;
    }
    else {
        style.appendChild(document.createTextNode(baseStyles));
    }
    document.head.appendChild(style);
}
